<template>
  <div class="cert">
    <mt-header title="信息认证">
      <mt-button icon="back" slot="left" @click="goback">返回</mt-button>
    </mt-header>
  	<div class="wrapper">
    	<div class="fsmtitle">
    		<span v-if="loginShape==1">您已通过壹签个人实名认证</span>
    		<span v-if="loginShape==2">您已通过壹签企业实名认证</span>
    	</div>
    	<div class="fsmcert">获颁证书信息为：</div>
    	<div class="certinfo">
    		<img src="/static/img/certinfo.png">
    		<div class="fabdiv">
	    		<div>颁发给：<span>{{certName}}</span></div>
	    		<div>颁发者：<span>iTrusChina</span></div>
	    		<div>证件号：<span>{{certnumber}}</span></div>
	    		<div>主题：<span>cn={{certName}}@{{certnumber}}</span></div>
	    		<div>付费方：<span>北京联合信任技术服务有限公司</span></div>
    		</div>
    	</div>
    </div>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        loginShape: "1",
        certName: "",
        certnumber: ""
      }
    },
    methods: {
      getCertinfo: function () {
        var _fcert = domain("_fcert");
        var that = this;
        that.$http.post(
          _fcert,
          {emulateJSON: true}
          )
          .then(function (response) {
            //接口返回数据,
            var result = response.data.data;
            this.loginShape = result.loginShape;
            this.certName = result.certName;
            this.certnumber = result.certnumber;
          }, function (error) {
            //Toast("数据获取响应异常.")
          }).catch(function (response) {
          //Toast("数据获取响应异常.")
          Indicator.close();
        })
      },
      goback: function () {
        history.go(-1); //后退1页
      }
    },
    mounted: function () {
      this.getCertinfo();
    }
  }
</script>
<style>
.cert .wrapper{
	width: 96%;
	margin: 0 auto;
}
.fsmtitle{
    color: #7d7d7d;
    margin-top: 10px;
    font-size: 1rem;
}
.fsmcert{
	color: #7d7d7d;
    font-size: 1rem;
}
.cert .certinfo{
	position: relative;
	transform: scale(0.9);
    transform-origin: 50% 0;
}
.cert .certinfo img{
	width:96%;
	margin: 0 auto;
}
.cert .fabdiv div{
    font-size: 16px;
    margin: 10px 10px 10px 50px;
}
.fabdiv{
	position: absolute;
	top: 40%;
	width: 90%;
}
.fabdiv span{
	color: #6d6d6d;
} 
</style>



// WEBPACK FOOTER //
// src/module/user/Fcert.vue